import type {
  ClientMiddleware,
  HeaderMap,
  MaybePromise,
  MiddlewareOnRequest,
} from '../types.js';

export type HeadersFactory = () => MaybePromise<HeaderMap>;

export const createHeadersMiddleware = ({
  getHeaders,
  preserveExisting = false,
}: {
  getHeaders: HeadersFactory;
  preserveExisting?: boolean;
}): ClientMiddleware => ({
  async onRequest({ request }: MiddlewareOnRequest) {
    const headers = await getHeaders();

    for (const [key, value] of Object.entries(headers)) {
      if (value == null) {
        continue;
      }

      if (preserveExisting && request.headers.has(key)) {
        continue;
      }

      request.headers.set(key, value);
    }

    return request;
  },
});
